import useSWR, { SWRConfiguration } from 'swr';

import { getCurrentLanguage } from '~/localization';
import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';
import { FormioI18n, FormioTranslations } from '~/types/forms';

export const overrideDefaultTranslations = (
  formI18n: FormioI18n,
  currentLanguage: string,
  t: (key: string) => string,
): FormioI18n => {
  return {
    ...formI18n,
    [currentLanguage]: Object.keys(formI18n[currentLanguage]).reduce(
      (acc, enKey) => {
        return {
          ...acc,
          [enKey]: t(enKey),
        };
      },
      {},
    ),
  };
};

export const useFormTranslations = (
  t: (key: string) => string,
  swrConfig?: SWRConfiguration,
) => {
  const formioLang = getCurrentLanguage();

  return useSWR<FormioTranslations>(
    !!formioLang ? ['getFormTranslations', formioLang] : null,
    ([_key, formioLang]) =>
      fetchFromNewApi(APIs.forms.getBuilder('employment', formioLang), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
        .then((r) => r.json())
        .then((formTranslations) => {
          return {
            ...formTranslations,
            language: formioLang,
            i18n: overrideDefaultTranslations(
              formTranslations?.i18n || {},
              formioLang,
              t,
            ),
          };
        }),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
